export interface IShopperStaffDiscountTransactionListItem {
    ID: number;
    OrderNumber: string;
    Total: number;
    TotalWithDiscount: number;
    Status: IShopperStaffDiscountTransactionStatus;
    Email: string;
    FullName: string;
    CurrencySign: string;
    DateTime: Date;
}

export enum IShopperStaffDiscountTransactionStatus {
    None = 0,
    Active = 1,
    Expired = 3,
    Archived = 4
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/IShopperStaffDiscountTransactionListItem.ts